import type { NavigationGuard } from 'vue-router';
import { usePB } from '@/composables/database/use-pocket-base.ts';
import { UsersModerationRoleOptions, type UsersRecord } from '@/types/pocketbase-types.ts';

export const moderatorGuard: NavigationGuard = (to) => {
  const pb = usePB();
  if (!pb.isLoggedIn.value) return { path: '/auth', query: { redirectUrl: to.fullPath } };
  const role = (pb.currentUser.value as UsersRecord | undefined)?.moderation_role;
  if (role !== UsersModerationRoleOptions.moderator && role !== UsersModerationRoleOptions.admin) return { path: '/events' };
};
